import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, isError, isHttpError, ok } from "@nju/result";
import { IInfoResult } from "../updateUser/types";

export async function updateEmail(
  oldEmail: string,
  newEmail: string,
): Promise<IInfoResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/preferences`,
    {
      method: "patch",
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
      json: [
        {
          op: "test",
          path: "/email",
          value: oldEmail,
        },
        {
          op: "replace",
          path: "/email",
          value: newEmail,
        },
      ],
    },
  );

  if (isError(result)) {
    if (isHttpError(result.err) && result.err.status === 409) {
      return err(
        new BasicError({
          code: "EMAIL_ALREADY_TAKEN",
          message: "New mail is already taken!",
        }),
      );
    }
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
